import React from 'react';
import { AlertCircleIcon, UsersIcon } from 'lucide-react';
import { ConfidenceBadge } from './ConfidenceBadge';
export type DuplicateSet = {
  id: string;
  primaryName: string;
  secondaryName: string;
  confidenceScore: number;
  conflictCount: number;
  matchCount: number;
  records: CustomerRecord[];
};
export type CustomerRecord = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  address: string;
  loanAmount: number;
  applicationDate: string;
  ssn: string;
  createdAt: string;
  source: string;
};
type DuplicateCardProps = {
  duplicateSet: DuplicateSet;
  isSelected: boolean;
  onClick: () => void;
};
export function DuplicateCard({
  duplicateSet,
  isSelected,
  onClick
}: DuplicateCardProps) {
  return <button onClick={onClick} className={`w-full p-4 rounded-lg border-2 transition-all duration-200 text-left focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${isSelected ? 'border-blue-500 bg-blue-50 shadow-md' : 'border-gray-200 bg-white hover:border-gray-300 hover:shadow-sm'}`} aria-pressed={isSelected} aria-label={`Duplicate set: ${duplicateSet.primaryName} and ${duplicateSet.secondaryName}, ${duplicateSet.confidenceScore}% match confidence`} data-id="element-58">
      <div className="flex items-start gap-3" data-id="element-59">
        <ConfidenceBadge score={duplicateSet.confidenceScore} size="sm" data-id="element-60" />

        <div className="flex-1 min-w-0" data-id="element-61">
          <div className="flex items-center gap-2 mb-1" data-id="element-62">
            <UsersIcon className="w-4 h-4 text-gray-400" aria-hidden="true" data-id="element-63" />
            <span className="text-sm font-medium text-gray-900 truncate" data-id="element-64">
              {duplicateSet.primaryName}
            </span>
          </div>
          <div className="flex items-center gap-2 mb-3" data-id="element-65">
            <div className="w-4 h-4" aria-hidden="true" data-id="element-66" />
            <span className="text-sm text-gray-600 truncate" data-id="element-67">
              {duplicateSet.secondaryName}
            </span>
          </div>

          <div className="flex items-center gap-3 text-xs" data-id="element-68">
            {duplicateSet.conflictCount > 0 && <span className="flex items-center gap-1 text-yellow-700 font-medium" data-id="element-69">
                <AlertCircleIcon className="w-3 h-3" aria-hidden="true" data-id="element-70" />
                {duplicateSet.conflictCount} conflicts
              </span>}
            <span className="text-green-700 font-medium" data-id="element-71">
              {duplicateSet.matchCount} matches
            </span>
          </div>
        </div>
      </div>
    </button>;
}